import { css, Theme } from "@mui/material";

import { getColor } from "@hooks";
import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

export const H2WithEmphasisMixin = (theme: Theme) => css`
  & > h2 {
    ${cssForHeaderWithLinearGradient(theme)}
    margin-bottom: 0.5rem;

    em {
      display: block;
      font-style: normal;
      color: ${getColor(c => c.tokens.text["soft-400"], theme)};
    }

    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_mobile)}
    }

    ${theme.breakpoints.up("tablet")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
    }

    ${theme.breakpoints.up("desktopXl")} {
      ${cssPropertiesToString(theme.typography.heading_h2_bold_desktop)}
    }
  }
`;
